import React, { ReactElement } from "react";
import FeedbackDetails from "../../components/Feedback/Details";
import Layout from "../../components/layout";

const FeedbackDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <FeedbackDetails />
    </Layout>
  );
};

export default FeedbackDetailsPage;
